import * as actionTypes from './actionTypes';

const initialState = {
  modals: {},
};


export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MODAL_OPEN:
      return {
        modals: {
          ...state.modals,
          [action.name]: {
            isOpen: true,
            payload: action.payload,
          },
        },
      };

    case actionTypes.MODAL_CLOSE:
      return {
        modals: {
          ...state.modals,
          [action.name]: {
            isOpen: false,
          },
        },
      };

    case actionTypes.MODAL_CLOSE_ALL:
      return {
        modals: Object.entries(state.modals).reduce(
          (obj, [modalName, modal]) => ({
            ...obj,
            [modalName]: {
              ...modal,
              isOpen: false,
            },
          }),
          {},
        ),
      };

    default:
      return state;
  }
};
